import {AsyncInlineError} from '@s-ui/decorators'

import {FetchOrFail} from '../../fetcher/Fetchers/FetchOrFail/index.js'
import {DeleteUserAdUserAdsError} from '../Errors/DeleteUserAdUserAdsError.js'
import {GetUserAdsError} from '../Errors/GetUserAdsError.js'
import {RenewUserAdsError} from '../Errors/RenewUserAdsError.js'
import {ListUserAdValueObject} from '../ValueObjects/ListUserAdValueObject.js'
import {UserAdsRepository} from './UserAdsRepository.js'

export class HTTPUserAdsRepository extends UserAdsRepository {
  #apiUrl
  #config
  #errors
  #fetchOrFail

  static create({config}) {
    return new HTTPUserAdsRepository({
      config,
      fetchOrFail: FetchOrFail.create({config})
    })
  }

  constructor({config, fetchOrFail}) {
    super()
    this.#config = config
    this.#fetchOrFail = fetchOrFail
    this.#apiUrl = this.#config.get('API_URL')
    this.#errors = this.#config.get('COMMON').ERRORS
  }

  @AsyncInlineError()
  async getUserAds({userEntity}) {
    const {GENERIC_ERROR} = this.#errors
    const userId = userEntity.getId()

    const [error, response] = await this.#fetchOrFail
      .withErrorsFactories({
        [GENERIC_ERROR]: () => GetUserAdsError.create({message: '[HTTPUserAdsRepository#getUserAds] Server error'})
      })
      .get(`${this.#apiUrl}/users/${userId}/ads/`)

    if (error) return Promise.reject(error)

    return ListUserAdValueObject.createFromApiResponse(response.data)
  }

  @AsyncInlineError()
  async renew({userEntity, adId}) {
    const {GENERIC_ERROR} = this.#errors
    const userId = userEntity.getId()

    const [error] = await this.#fetchOrFail
      .withErrorsFactories({
        [GENERIC_ERROR]: () =>
          RenewUserAdsError.create({message: '[HTTPUserAdsRepository#renew] Error renewing user ad'})
      })
      .post(`${this.#apiUrl}/users/${userId}/renewed-ads/${adId}`)

    if (error) return Promise.reject(error)

    return true
  }

  @AsyncInlineError()
  async deleteUserAd({userEntity, adId}) {
    const {GENERIC_ERROR} = this.#errors
    const userId = userEntity.getId()

    const [error] = await this.#fetchOrFail
      .withErrorsFactories({
        [GENERIC_ERROR]: () =>
          DeleteUserAdUserAdsError.create('[HTTPUserAdsRepository#deleteUserAd] Error deleting user ad')
      })
      .delete(`${this.#apiUrl}/users/${userId}/ads/${adId}`)

    if (error) return Promise.reject(error)

    return true
  }
}
